import React, { useState } from "react";
import { useApi } from "../../utils/api";
import { useUserInfo } from "../../utils/user";
import { Grid2, Typography, Card, Button } from "@mui/material";

const CoachingSignUpCreateStripeAccount = () => {
  const { email } = useUserInfo();
  const { createAccount, updateUser } = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCreateAccount = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await createAccount(email);
      if (!response.account) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const accountId = response.account;
      await updateUser({
        stripeAccountId: accountId,
      });
      window.location.href = "/coaching/create-account-link";
    } catch (err) {
      console.error("Error creating account:", err);
      setError(
        "Failed to create account. Please try again. Error: " + err.message
      );
    }
  };

  return (
    <Grid2 container justifyContent="center" sx={{ m: 4 }}>
      <Grid2 item lg={6} sm={12}>
        <Card sx={{ p: 3, mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
            Setting Up Your Account
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
            Trainer App uses Stripe to manage payments and subscriptions. You'll
            need to create a Stripe account and connect it to collect payments
            on our platform.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
            Trainer App will take a portion of every transaction based on your
            revenue. So starting up is free, and you'll only pay when you make a
            sale. 5% for the first $3,000, 4% for the next $5,000, and 3.5% for
            the remaining revenue.
            <Link href="/pricing" target="_blank">
              Learn more
            </Link>
          </Typography>
          <Button
            variant="contained"
            onClick={handleCreateAccount}
            sx={{ mt: 2, display: "block", mx: "auto" }}
            loading={isLoading}
            disabled={isLoading}
          >
            Create Stripe Account
          </Button>
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default CoachingSignUpCreateStripeAccount;
